import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const sceneBackground = {
    variant: "insetBox",
    padding: "5%",
    borderRadius: "3rem",
    boxColor: "rgb(71 25 36 / 85%)",
};
const images = {
    "heart-1": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-1.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-1.webp`,
        width: 1005,
        height: 1184,
    },
    "heart-2": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-2.webp`,
        width: 1016,
        height: 1072,
    },
    "heart-3": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-3.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-3.png`,
        width: 968,
        height: 1385,
    },
    "heart-4": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-4.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-4.webp`,
        width: 975,
        height: 989,
    },
    "heart-5": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-5.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-5.webp`,
        width: 629,
        height: 607,
    },
    "heart-6": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-6.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-6.webp`,
        width: 1144,
        height: 1301,
    },
    "heart-7": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-7.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-7.webp`,
        width: 600,
        height: 578,
    },
    "heart-8": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-8.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-8.webp`,
        width: 771,
        height: 784,
    },
    "heart-9": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-9.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-9.webp`,
        width: 458,
        height: 474,
    },
    "heart-10": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-10.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-10.webp`,
        width: 1038,
        height: 1077,
    },
    "heart-11": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-11.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-11.webp`,
        width: 938,
        height: 1114,
    },
    "heart-12": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-12.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-12.webp`,
        width: 602,
        height: 714,
    },
    "heart-13": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-13.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-13.webp`,
        width: 878,
        height: 1043,
    },
    "heart-14": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-14.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-14.webp`,
        width: 692,
        height: 717,
    },
    "heart-15": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-15.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-15.webp`,
        width: 382,
        height: 351,
    },
    "heart-16": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-16.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-16.webp`,
        width: 391,
        height: 449,
    },
    "heart-17": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-17.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-17.webp`,
        width: 407,
        height: 479,
    },
    "heart-18": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-18.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-18.png`,
        width: 797,
        height: 768,
    },
    "heart-19": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-19.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-19.webp`,
        width: 458,
        height: 474,
    },
    "heart-20": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-20.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-20.webp`,
        width: 346,
        height: 408,
    },
    "heart-mask": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/heart-mask.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/heart-mask.webp`,
        width: 312,
        height: 279,
    },
    "hessian-texture": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/hessian-texture.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/pop-hearts/optimized/hessian-texture.png`,
        width: 1920,
        height: 1277,
    },
};
// We're setting the width/height of the heart image to the full-size
// width/height, which will make their sizes consistent when using full-size or
// preview images. However, the full size is too big, so we need to scale them
// down.
const BACKGROUND_HEART_SCALE = 0.25;
const backgroundHearts = [
    {
        src: images["heart-1"],
        topStart: 4,
        leftStart: 14,
        topPopped: -11,
        leftPopped: 5,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-2"],
        topStart: 43,
        leftStart: 3,
        topPopped: 53,
        leftPopped: -6,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-3"],
        topStart: 7,
        leftStart: 52,
        topPopped: -13,
        leftPopped: 51,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-4"],
        topStart: 61,
        leftStart: 38,
        topPopped: 72,
        leftPopped: 38,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-5"],
        topStart: 31,
        leftStart: 68,
        topPopped: 11,
        leftPopped: 66,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-6"],
        topStart: 58,
        leftStart: 80,
        topPopped: 69,
        leftPopped: 94,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-7"],
        topStart: 47,
        leftStart: 22.5,
        topPopped: 23,
        leftPopped: 0.5,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-8"],
        topStart: 73,
        leftStart: 56,
        topPopped: 86,
        leftPopped: 55,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-9"],
        topStart: 74,
        leftStart: 15,
        topPopped: 84,
        leftPopped: 16,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-10"],
        topStart: 26,
        leftStart: 32,
        topPopped: 1,
        leftPopped: 24,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-12"],
        topStart: 3,
        leftStart: 74,
        topPopped: -12,
        leftPopped: 76,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-13"],
        topStart: 21,
        leftStart: 79,
        topPopped: 11,
        leftPopped: 80,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-16"],
        topStart: 21,
        leftStart: 3,
        topPopped: 10,
        leftPopped: -3,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-17"],
        topStart: 81,
        leftStart: 5,
        topPopped: 87,
        leftPopped: 2,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-18"],
        topStart: 53,
        leftStart: 65,
        topPopped: 75,
        leftPopped: 74,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-19"],
        topStart: 8,
        leftStart: 90,
        topPopped: -4,
        leftPopped: 94,
        scale: BACKGROUND_HEART_SCALE,
    },
    {
        src: images["heart-20"],
        topStart: 85,
        leftStart: 72,
        topPopped: 93,
        leftPopped: 69,
        scale: BACKGROUND_HEART_SCALE,
    },
];
export const popHearts = {
    version: 1,
    themeId: "pop-hearts",
    name: "Pop Hearts",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/pop-hearts.webp`,
    background: [
        {
            variant: "pop-hearts",
            src: images["hessian-texture"],
            hearts: backgroundHearts,
            popAnimationDurationSeconds: 0.4,
            popAtSeconds: 1.35,
            restoreAtSeconds: 5.2,
        },
    ],
    scenes: [
        {
            type: "generalSolidIntro",
            durationSeconds: 5.25,
            transitionVariant: "pop-scale",
            faceCollage: {
                variant: "top-bottom-static",
                startAtSeconds: 1,
                entrance: {
                    variant: "heart-mask",
                    maskAssetUrl: images["heart-mask"].full,
                    transitionDurationInFrames: 12,
                    exitDurationInFrames: 12,
                },
            },
            title: {
                fontFamily: "Glass Antiqua",
                fontSize: 200,
                fontWeight: "extralight",
                letterSpacing: "widest",
            },
        },
        {
            type: "greeting",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            betweenMessageTransition: {
                variant: "scale",
                enterDurationSeconds: 0.33333,
                exitDurationSeconds: 0.16666,
            },
            showLogo: true,
            sceneBackground,
            messageAssets: [
                [
                    {
                        style: {
                            zIndex: 10,
                            translate: "-42% -42%",
                            rotate: "-20deg",
                            scale: "0.12",
                        },
                        url: images["heart-4"],
                    },
                    {
                        style: {
                            zIndex: 10,
                            translate: "41% 1%",
                            rotate: "20deg",
                            scale: "0.12",
                        },
                        url: images["heart-18"],
                    },
                ],
                [
                    {
                        style: {
                            zIndex: 10,
                            translate: "42% -42%",
                            rotate: "20deg",
                            scale: "0.09",
                        },
                        url: images["heart-8"],
                    },
                    {
                        style: {
                            zIndex: 10,
                            translate: "-41% -4%",
                            rotate: "-20deg",
                            scale: "0.12",
                        },
                        url: images["heart-2"],
                    },
                ],
                [
                    {
                        style: {
                            zIndex: 10,
                            translate: "-42% -44%",
                            rotate: "-20deg",
                            scale: "0.08",
                        },
                        url: images["heart-3"],
                    },
                    {
                        style: {
                            zIndex: 10,
                            translate: "43% -7%",
                            rotate: "14deg",
                            scale: "0.08",
                        },
                        url: images["heart-6"],
                    },
                ],
            ],
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greeting",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            betweenMessageTransition: {
                variant: "scale",
                enterDurationSeconds: 0.33333,
                exitDurationSeconds: 0.16666,
            },
            showLogo: true,
            sceneBackground,
            messageAssets: [
                [
                    {
                        style: {
                            zIndex: 10,
                            translate: "-42% -44%",
                            rotate: "-20deg",
                            scale: "0.09",
                        },
                        url: images["heart-1"],
                    },
                    {
                        style: {
                            zIndex: 10,
                            translate: "42% -8%",
                            rotate: "20deg",
                            scale: "0.1",
                        },
                        url: images["heart-16"],
                    },
                ],
                [
                    {
                        style: {
                            zIndex: 10,
                            translate: "43% -43%",
                            rotate: "20deg",
                            scale: "0.09",
                        },
                        url: images["heart-7"],
                    },
                    {
                        style: {
                            zIndex: 10,
                            translate: "-42% 2%",
                            rotate: "-20deg",
                            scale: "0.11",
                        },
                        url: images["heart-5"],
                    },
                ],
                [
                    {
                        style: {
                            zIndex: 10,
                            translate: "-42% -44%",
                            rotate: "-29deg",
                            scale: "0.08",
                        },
                        url: images["heart-13"],
                    },
                    {
                        style: {
                            zIndex: 10,
                            translate: "43% -7.75%",
                            rotate: "20deg",
                            scale: "0.07",
                        },
                        url: images["heart-17"],
                    },
                ],
            ],
        },
        {
            type: "popHeartsOutro",
            popOutStartSeconds: 1.33,
            animationDurationSeconds: 0.4,
            hearts: backgroundHearts,
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "white",
            fontFamily: "Glass Antiqua",
            fontWeight: "light",
            fontSize: 130,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#431722",
                        backgroundOpacity: 0.95,
                    },
                ],
            },
            betweenTransition: {
                variant: "roundedRectReveal",
                timing: {
                    variant: "linear",
                    durationSeconds: 1,
                    easing: "easeOut",
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#FFFFFF",
                fontFamily: "Glass Antiqua",
                fontWeight: "light",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#FFFFFF",
                fontFamily: "Glass Antiqua",
                fontWeight: "light",
                fontSize: 40,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.9,
            borderRadius: "3.25rem",
            boxShadow: "0rem 0.25rem 1rem -2px rgba(0, 0, 0, 0.75)",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "scale",
            timing: {
                variant: "linear",
                durationSeconds: 0.3,
            },
        },
    },
    userInputFields: [
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Happy 50th Anniversary!",
            required: true,
            min: 1,
            max: 50,
            preview: {
                sceneIndex: 0,
                frameOffset: 50,
            },
        },
    ],
};
